export function appFlags(appName) {
  const app = appName || '';

  return {
    app,
    isAdmin: app.includes('admin'),
    isPartner: app.includes('partner'),
    isCustomer: app.includes('customer'),
    isLocator: app.includes('locator'),
    isProduction: app.includes('production'),
  };
}
